var e = {
	greetings: {
		g1: "Ready for your next guest?",
		g2: "Your properties are looking good.",
		g3: "Let's get those bookings up.",
		g4: "Welcome back, Host.",
		g5: "How's the hosting going today?",
		g6: "You have new activity to check.",
		g7: "Manage your empire.",
		g8: "Hosting made simple.",
		g9: "Your business at a glance.",
		g10: "Let's maximize your occupancy.",
		g11: "Ready to welcome the world?",
		g12: "Check in on your listings.",
		g13: "Stay on top of your bookings.",
		g14: "Your guests are waiting.",
		g15: "Everything's under control.",
		g16: "Optimize your performance.",
		g17: "Your hosting journey continues.",
		g18: "New inquiries are landing.",
		g19: "Keep that 5-star streak going.",
		g20: "Manage smarter, not harder.",
		g21: "Your property, your rules.",
		g22: "Track your earnings.",
		g23: "Let's prep for the next arrival.",
		g24: "Hosting excellence starts here.",
		g25: "Your dashboard is up to date.",
		g26: "See what's happening at your properties.",
		g27: "A great stay starts with a great host.",
		g28: "Streamline your workflow.",
		g29: "Ready to grow your revenue?",
		g30: "You're making an impact."
	},
	quickActions: {
		blockDates: {
			label: "Block Dates",
			description: "Mark unavailable dates"
		},
		addProperty: {
			label: "Add Property",
			description: "List a new property"
		},
		propertySettings: {
			label: "Property Settings",
			description: "Update rules & pricing"
		},
		createCoupon: {
			label: "Create Coupon",
			description: "Offer a discount"
		},
		writeGuide: {
			label: "Write a Guide",
			description: "Share local tips"
		},
		inviteCohost: {
			label: "Invite Co-host",
			description: "Add someone to your team"
		}
	},
	balance: {
		title: "Available Funds",
		requestWithdrawal: "Request Withdrawal",
		upcomingPayments: "Upcoming Payments",
		noUpcomingPayments: "No upcoming payments",
		availableOn: "Available {{date}}"
	},
	schedule: {
		title: "My Schedule",
		dayEmpty: "Nothing scheduled for this day.",
		blocked: "Blocked",
		icalBlocked: "Imported block",
		viewAll: "All bookings",
		arriving: "Arriving",
		departing: "Departing",
		showAll: "Show all {{count}}"
	},
	occupancy: {
		title: "Occupancy Rate",
		annualAvg: "annual avg",
		occupied: "Occupied",
		vacant: "Vacant",
		noData: "No occupancy data yet.",
		windowAvg: "avg over {{count}} months",
		viewCalendar: "Calendar"
	},
	revenue: {
		title: "Revenue Trends",
		yoyGrowth: "+{{value}}% YoY",
		totalThisPeriod: "total this period",
		monthlyAvg: "Monthly Avg",
		bestMonth: "Best Month",
		vsLastYear: "vs Last Year",
		thisYear: "This Year",
		lastYear: "Last Year",
		yoyDecline: "{{value}}% YoY",
		viewEarnings: "Earnings",
		empty: {
			title: "No revenue yet",
			body: "It'll show up here once your first stay checks in."
		},
		emptyListing: {
			title: "No revenue for this listing yet",
			body: "It'll show up here once this listing's first stay checks in."
		}
	},
	responseStats: {
		title: "Response time",
		avgLabel: "Average response time",
		rateLabel: "Response rate",
		window: "Last {{days}} days",
		turnsCount_one: "{{count}} guest message",
		turnsCount_other: "{{count}} guest messages",
		guestPreview: "What guests see",
		bucketHidden: "Guests see your response rate only until it reaches {{pct}}%",
		empty: {
			title: "Not enough messages yet",
			description_one: "Your response time appears once you've answered {{count}} guest message in the last {{days}} days.",
			description_other: "Your response time appears once you've answered {{count}} guest messages in the last {{days}} days."
		},
		notComputed: "Calculated daily"
	}
};
//#endregion
export { e as default };
